import { DEV } from "./environment.dev";
import { PROD } from "./environment.prod";
import { TEST } from "./environment.test";

import { IConfiguration } from "./IConfiguration";
import { Environment } from "./Environment";

export { Environment };
export type { IConfiguration };

export const getConfiguration = (_env?: Environment): IConfiguration => {
	const env: Environment = _env || process.env.REACT_APP_SENDUM_CONFIG_ENV as Environment;

	switch (env) {
		case Environment.PROD: {
			return { ...PROD };
		}
		case Environment.DEV: {
			return { ...DEV };
		}
		case Environment.TEST: {
			return { ...TEST };
		}
		default: {
			return { ...DEV };
		}
	}
};
